import * as angular from 'angular';
import { ChilduppPropertiesService } from './services/childupp-properties.service';
import { ChilduppRuntimeService } from './services/childupp-runtime.service';

const module = angular.module('childupp.core', []);

const registerService = (serviceClass) => module.service(serviceClass.$serviceName, serviceClass);

registerService(ChilduppPropertiesService);
registerService(ChilduppRuntimeService);

export default module



// WEBPACK FOOTER //
// ./src/app/core/index.js